import { TcgCard } from "./TcgCard";
import type { TcgCardItem } from "./types";

interface TcgCardGridProps {
  cards: TcgCardItem[];
  onOpenCard: (index: number) => void;
}

export const TcgCardGrid = ({ cards, onOpenCard }: TcgCardGridProps) => {
  if (cards.length === 0) {
    return null;
  }

  return (
    <ul className="m-0 grid list-none gap-3 p-0 [grid-template-columns:repeat(auto-fill,minmax(9rem,1fr))] max-md:gap-2.5">
      {cards.map((card, index) => (
        <li key={card.id}>
          <TcgCard
            title={card.title}
            imageUrl={card.imageUrl}
            onOpen={() => {
              onOpenCard(index);
            }}
          />
        </li>
      ))}
    </ul>
  );
};
